import { createFileRoute } from '@tanstack/react-router'
import { useSuspenseQuery } from '@tanstack/react-query'
import { trpc } from '@/main'
import { useJob } from '@/hooks/use-job'
import { BoardPending } from './-components/shared/board-pending'
import { Board } from './-components/shared/board'
import { EmptyState } from './-components/shared/empty-state'
import { GroupContextProvider } from './-components/shared/group-context'

export const Route = createFileRoute('/_app/jobs/$jobId/board')({
  loaderDeps: ({ search }) => ({ type: search.type }),
  loader: ({ context, deps, params }) => {
    context.queryClient.prefetchQuery(
      trpc.companies.getJobIntegrantIndicators.queryOptions({ jobId: Number(params.jobId), type: deps.type }),
    )
  },
  component: RouteComponent,
  pendingComponent: BoardPending,
})

function RouteComponent() {
  const { jobId } = Route.useParams()
  const { jobIntegrants } = useJob(Number(jobId))
  const { data: job } = useSuspenseQuery(trpc.jobs.getJob.queryOptions({ jobId: Number(jobId) }))

  const members = (jobIntegrants?.members ?? []).map((member) => ({
    ...member,
    id: member.id,
  }))

  if (jobIntegrants?.emptyStateCode) {
    return <EmptyState code={jobIntegrants.emptyStateCode} surface="board" />
  }

  return (
    <GroupContextProvider type="job">
      <Board name={job.name ?? ''} profiles={members} standardIndicators={jobIntegrants?.indicators} />
    </GroupContextProvider>
  )
}
